export const movies = [
  {
    id: "m1",
    title: "流浪地球3",
    category: "movie",
    genre: "科幻",
    region: "中国大陆",
    year: 2025,
    rating: 8.9,
    heat: 9980,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20of%20a%20giant%20planet%20engine%20over%20a%20frozen%20earth%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20space%20lighting%2C%20film%20grain%2C%20centered%20composition%2C%20highly%20detailed%20poster%20art&width=400&height=600&seq=mv01cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20still%20of%20a%20colossal%20planetary%20engine%20towering%20above%20a%20snow%20covered%20city%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20moody%20atmosphere%2C%20highly%20detailed&width=1600&height=900&seq=mv01back&orientation=landscape",
    summary: "太阳即将氦闪，人类启动行星发动机推动地球流浪宇宙。新一代宇航员在危机边缘挺身而出，与时间赛跑寻找新的家园。",
    cast: ["吴京", "刘德华", "李雪健"],
  },
  {
    id: "m2",
    title: "满江红",
    category: "movie",
    genre: "悬疑",
    region: "中国大陆",
    year: 2023,
    rating: 8.2,
    heat: 9420,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20suspense%20movie%20poster%20of%20a%20lone%20warrior%20in%20a%20dark%20courtyard%20with%20red%20lanterns%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20film%20grain%2C%20centered%20composition%2C%20highly%20detailed%20poster%20art&width=400&height=600&seq=mv02cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20palace%20courtyard%20at%20night%20with%20hanging%20red%20lanterns%20and%20mist%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20moody%20suspense%20film%20still%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1600&height=900&seq=mv02back&orientation=landscape",
    summary: "南宋绍兴年间，一桩悬案牵动朝野。小兵与亲兵联手追查真相，层层反转之下，一封密信揭开惊天秘密。",
    cast: ["沈腾", "易烊千玺", "张译"],
  },
  {
    id: "m3",
    title: "消失的她",
    category: "movie",
    genre: "悬疑",
    region: "中国大陆",
    year: 2023,
    rating: 8.0,
    heat: 9180,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20thriller%20movie%20poster%20of%20a%20woman%20silhouette%20reflected%20in%20broken%20mirrors%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20film%20grain%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv03cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20thriller%20film%20still%20of%20an%20empty%20seaside%20hotel%20corridor%20at%20dusk%20with%20long%20shadows%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20tense%20mood%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv03back&orientation=landscape",
    summary: "妻子在旅行中神秘失踪，丈夫四处寻找却遇到自称妻子的陌生女人。真相随着调查层层剥开，结局令人窒息。",
    cast: ["朱一龙", "倪妮", "文咏珊"],
  },
  {
    id: "m4",
    title: "封神第一部",
    category: "movie",
    genre: "奇幻",
    region: "中国大陆",
    year: 2023,
    rating: 8.4,
    heat: 9600,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20mythology%20fantasy%20movie%20poster%20of%20an%20armored%20warrior%20holding%20a%20glowing%20sword%20before%20an%20ancient%20battlefield%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv04cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20chinese%20mythology%20battlefield%20with%20thousands%20of%20soldiers%20and%20giant%20statues%20under%20a%20stormy%20sky%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20highly%20detailed&width=1600&height=900&seq=mv04back&orientation=landscape",
    summary: "殷寿与姬发之间的父子纠葛，在封神大战的序幕中展开。少年英雄踏上反抗暴君的征途，神魔两界的命运由此改写。",
    cast: ["费翔", "李雪健", "黄渤"],
  },
  {
    id: "m5",
    title: "孤注一掷",
    category: "movie",
    genre: "犯罪",
    region: "中国大陆",
    year: 2023,
    rating: 7.9,
    heat: 8760,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20young%20man%20trapped%20behind%20glowing%20phone%20screens%20in%20a%20dark%20room%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv05cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20film%20still%20of%20a%20crowded%20neon%20lit%20call%20center%20at%20night%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20tense%20urban%20mood%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv05back&orientation=landscape",
    summary: "程序员被诱骗至境外诈骗集团，在绝境中寻找逃生之路。真实案件改编，揭开网络诈骗背后的黑暗链条。",
    cast: ["张艺兴", "金晨", "咏梅"],
  },
  {
    id: "m6",
    title: "热辣滚烫",
    category: "movie",
    genre: "喜剧",
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    heat: 8890,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20uplifting%20drama%20movie%20poster%20of%20a%20determined%20woman%20boxer%20wrapping%20her%20hands%20in%20a%20gym%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv06cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20sports%20drama%20film%20still%20of%20an%20empty%20boxing%20gym%20with%20warm%20morning%20light%20through%20windows%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20hopeful%20mood%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv06back&orientation=landscape",
    summary: "宅家多年的乐莹在人生低谷中决定改变自己，走上拳击擂台。一场关于自我救赎与勇气的热血旅程。",
    cast: ["贾玲", "雷佳音", "张小斐"],
  },
  {
    id: "m7",
    title: "沙丘2",
    category: "movie",
    genre: "科幻",
    region: "美国",
    year: 2024,
    rating: 8.7,
    heat: 9310,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20desert%20movie%20poster%20of%20a%20hooded%20hero%20standing%20before%20giant%20sand%20dunes%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv07cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20still%20of%20vast%20orange%20desert%20dunes%20with%20a%20colossal%20sandworm%20rising%20under%20a%20hazy%20sky%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv07back&orientation=landscape",
    summary: "保罗与弗雷曼人结盟，向背叛家族的敌人复仇。在命运与预言之间，他必须选择成为救世主还是毁灭者。",
    cast: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森"],
  },
  {
    id: "m8",
    title: "奥本海默",
    category: "movie",
    genre: "传记",
    region: "美国",
    year: 2023,
    rating: 8.8,
    heat: 9050,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20biography%20drama%20movie%20poster%20of%20a%20pensive%20scientist%20silhouette%20before%20a%20glowing%20atomic%20cloud%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv08cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20film%20still%20of%20a%20desert%20test%20site%20with%20a%20tower%20and%20dramatic%20sky%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20tense%20historic%20mood%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv08back&orientation=landscape",
    summary: "原子弹之父奥本海默的传奇一生，在科学、政治与良知之间挣扎。曼哈顿计划背后的荣耀与阴影。",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
  },
  {
    id: "m9",
    title: "碟中谍7",
    category: "movie",
    genre: "动作",
    region: "美国",
    year: 2023,
    rating: 8.3,
    heat: 8640,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20spy%20movie%20poster%20of%20an%20agent%20leaping%20between%20rooftops%20at%20dusk%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv09cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20action%20film%20still%20of%20a%20high%20speed%20train%20chase%20across%20a%20mountain%20viaduct%20at%20sunset%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv09back&orientation=landscape",
    summary: "伊森·亨特再度出击，面对能操控全球情报的超级人工智能。一场关乎人类命运的终极任务就此展开。",
    cast: ["汤姆·克鲁斯", "海莉·阿特维尔", "丽贝卡·弗格森"],
  },
  {
    id: "m10",
    title: "铃芽之旅",
    category: "movie",
    genre: "动画",
    region: "日本",
    year: 2023,
    rating: 8.5,
    heat: 8420,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20anime%20movie%20poster%20of%20a%20girl%20standing%20before%20a%20glowing%20ancient%20door%20in%20the%20sky%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20soft%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv10cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=breathtaking%20anime%20film%20still%20of%20a%20coastal%20town%20under%20a%20vast%20sky%20with%20floating%20doors%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20highly%20detailed%20painterly%20style&width=1600&height=900&seq=mv10back&orientation=landscape",
    summary: "少女铃芽偶遇神秘青年，为关闭引发灾难的“门”踏上旅途。一场跨越日本、治愈心灵的奇幻冒险。",
    cast: ["原菜乃华", "松村北斗", "深津绘里"],
  },
  {
    id: "m11",
    title: "釜山行",
    category: "movie",
    genre: "惊悚",
    region: "韩国",
    year: 2016,
    rating: 8.6,
    heat: 7980,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20zombie%20horror%20movie%20poster%20of%20survivors%20barricaded%20inside%20a%20train%20carriage%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv11cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20horror%20film%20still%20of%20an%20abandoned%20train%20station%20platform%20at%20night%20with%20flickering%20lights%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20tense%20mood%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv11back&orientation=landscape",
    summary: "一场病毒疫情在列车上爆发，乘客们为生存奋力搏斗。在绝境之中，人性的光辉与阴暗同时上演。",
    cast: ["孔刘", "马东锡", "郑有美"],
  },
  {
    id: "m12",
    title: "寄生虫",
    category: "movie",
    genre: "剧情",
    region: "韩国",
    year: 2019,
    rating: 8.8,
    heat: 8250,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20social%20drama%20movie%20poster%20of%20a%20family%20silhouette%20descending%20a%20narrow%20basement%20staircase%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv12cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20still%20of%20a%20luxurious%20modern%20house%20overlooking%20a%20rainy%20city%20at%20night%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv12back&orientation=landscape",
    summary: "住在半地下室的一家人逐步渗透进富豪家庭，看似完美的计划却因一个秘密而失控。阶级寓言式的黑色杰作。",
    cast: ["宋康昊", "李善均", "曹如晶"],
  },
  {
    id: "m13",
    title: "星际迷航：新纪元",
    category: "movie",
    genre: "科幻",
    region: "美国",
    year: 2024,
    rating: 8.0,
    heat: 7890,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20space%20opera%20movie%20poster%20of%20a%20starship%20silhouette%20before%20a%20colorful%20nebula%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv13cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20still%20of%20a%20starship%20bridge%20with%20glowing%20screens%20and%20a%20view%20of%20deep%20space%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv13back&orientation=landscape",
    summary: "企业号船员踏上探索未知星域的旅程，却意外唤醒沉睡千年的古老文明。一次关于探索与和平的星际远征。",
    cast: ["克里斯·派恩", "佐伊·索尔达娜", "西蒙·佩吉"],
  },
  {
    id: "m14",
    title: "哥斯拉大战金刚2",
    category: "movie",
    genre: "动作",
    region: "美国",
    year: 2024,
    rating: 7.6,
    heat: 7760,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20monster%20movie%20poster%20of%20two%20colossal%20creatures%20facing%20off%20in%20a%20neon%20city%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv14cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20monster%20film%20still%20of%20a%20giant%20creature%20rising%20from%20the%20ocean%20near%20a%20coastal%20city%20at%20dusk%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv14back&orientation=landscape",
    summary: "泰坦巨兽再度苏醒，地球危在旦夕。哥斯拉与金刚被迫联手，对抗来自地心的全新威胁。",
    cast: ["丽贝卡·霍尔", "布莱恩·泰里·亨利", "丹·史蒂文斯"],
  },
  {
    id: "m15",
    title: "铃芽的夏日",
    category: "movie",
    genre: "剧情",
    region: "日本",
    year: 2022,
    rating: 7.8,
    heat: 6880,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20drama%20movie%20poster%20of%20a%20girl%20on%20a%20bicycle%20by%20a%20seaside%20road%20in%20summer%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20soft%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv15cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20drama%20film%20still%20of%20a%20quiet%20seaside%20town%20at%20golden%20hour%20with%20wires%20and%20small%20houses%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv15back&orientation=landscape",
    summary: "一个海滨小镇的夏天，少女在成长与告别之间徘徊。平淡日常中流淌着最动人的温情。",
    cast: ["广濑铃", "山崎贤人", "松隆子"],
  },
  {
    id: "m16",
    title: "都市夜行者",
    category: "movie",
    genre: "犯罪",
    region: "中国香港",
    year: 2024,
    rating: 8.1,
    heat: 7320,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20neo%20noir%20crime%20movie%20poster%20of%20a%20lone%20figure%20under%20neon%20signs%20in%20rain%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=mv16cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20neo%20noir%20film%20still%20of%20a%20rainy%20hong%20kong%20street%20with%20colorful%20neon%20signs%20at%20night%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv16back&orientation=landscape",
    summary: "退休警探重返街头，追查一桩连环失踪案。霓虹灯下的都市，每个人都有自己的秘密。",
    cast: ["梁家辉", "刘青云", "张柏芝"],
  },
  {
    id: "t1",
    title: "狂飙",
    category: "tv",
    genre: "犯罪",
    region: "中国大陆",
    year: 2023,
    rating: 9.1,
    heat: 9920,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20series%20poster%20of%20two%20rival%20men%20standing%20back%20to%20back%20in%20a%20city%20alley%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv01cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20crime%20series%20still%20of%20an%20old%20southern%20chinese%20city%20street%20at%20dusk%20with%20warm%20lights%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv01back&orientation=landscape",
    summary: "一名理想主义刑警与一个精明商贩跨越二十年的正邪较量。时代洪流之下，选择如何将被选择改写。",
    cast: ["张译", "张颂文", "李一桐"],
    episodes: [
      { index: 1, title: "第1集 安欣的第一桩案子" },
      { index: 2, title: "第2集 旧厂街的年轻人" },
      { index: 3, title: "第3集 第一次交锋" },
      { index: 4, title: "第4集 暗流涌动" },
      { index: 5, title: "第5集 十年之后" },
      { index: 6, title: "第6集 最后的对峙" },
    ],
  },
  {
    id: "t2",
    title: "三体",
    category: "tv",
    genre: "科幻",
    region: "中国大陆",
    year: 2023,
    rating: 8.8,
    heat: 9450,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20series%20poster%20of%20a%20giant%20radio%20telescope%20dish%20under%20a%20starry%20sky%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv02cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20series%20still%20of%20a%20vast%20desert%20observatory%20under%20a%20swirling%20night%20sky%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv02back&orientation=landscape",
    summary: "物理学家接连离奇死亡，一场跨越星际的文明对话悄然展开。人类在三体世界的凝视下，走向未知的命运。",
    cast: ["张鲁一", "于和伟", "陈瑾"],
    episodes: [
      { index: 1, title: "第1集 科学边界的死亡" },
      { index: 2, title: "第2集 三体游戏" },
      { index: 3, title: "第3集 红岸基地的秘密" },
      { index: 4, title: "第4集 面壁计划" },
      { index: 5, title: "第5集 宇宙社会学" },
      { index: 6, title: "第6集 黑暗森林" },
    ],
  },
  {
    id: "t3",
    title: "漫长的季节",
    category: "tv",
    genre: "悬疑",
    region: "中国大陆",
    year: 2023,
    rating: 9.2,
    heat: 9680,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20series%20poster%20of%20an%20old%20factory%20town%20under%20amber%20autumn%20light%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv03cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20series%20still%20of%20a%20rusty%20northeastern%20factory%20town%20railway%20at%20golden%20hour%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv03back&orientation=landscape",
    summary: "一桩尘封多年的碎尸案，串联起东北小城几个普通人跌宕的半生。时间漫长，命运如歌。",
    cast: ["范伟", "秦昊", "陈明昊"],
    episodes: [
      { index: 1, title: "第1集 秋天来了" },
      { index: 2, title: "第2集 桦钢往事" },
      { index: 3, title: "第3集 谁在说谎" },
      { index: 4, title: "第4集 真相浮现" },
      { index: 5, title: "第5集 漫长的季节" },
    ],
  },
  {
    id: "t4",
    title: "繁花",
    category: "tv",
    genre: "剧情",
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    heat: 8930,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20retro%20drama%20series%20poster%20of%20a%20man%20in%20a%20vintage%20suit%20in%20a%20warm%20lit%20shanghai%20alley%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv04cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20retro%20drama%20series%20still%20of%201990s%20shanghai%20street%20at%20night%20with%20warm%20yellow%20lights%20and%20rain%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv04back&orientation=landscape",
    summary: "九十年代的上海滩，小人物阿宝在大时代里起落沉浮。繁华背后，是一代人的野心与遗憾。",
    cast: ["胡歌", "马伊琍", "唐嫣"],
    episodes: [
      { index: 1, title: "第1集 上海往事" },
      { index: 2, title: "第2集 阿宝的生意" },
      { index: 3, title: "第3集 繁花落尽" },
      { index: 4, title: "第4集 大浪淘沙" },
    ],
  },
  {
    id: "t5",
    title: "莲花楼",
    category: "tv",
    genre: "古装",
    region: "中国大陆",
    year: 2023,
    rating: 8.4,
    heat: 8610,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20costume%20series%20poster%20of%20a%20swordsman%20before%20a%20misty%20mountain%20pavilion%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv05cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20series%20still%20of%20a%20misty%20mountain%20and%20ancient%20pavilion%20at%20dawn%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv05back&orientation=landscape",
    summary: "昔日天下第一高手隐姓埋名，化身江湖郎中浪迹天涯。一桩桩奇案背后，藏着他不愿提起的过去。",
    cast: ["成毅", "曾舜晞", "肖顺尧"],
    episodes: [
      { index: 1, title: "第1集 江湖郎中" },
      { index: 2, title: "第2集 奇案初现" },
      { index: 3, title: "第3集 莲花楼" },
      { index: 4, title: "第4集 旧人重逢" },
      { index: 5, title: "第5集 真相大白" },
    ],
  },
  {
    id: "t6",
    title: "怪奇物语第四季",
    category: "tv",
    genre: "悬疑",
    region: "美国",
    year: 2022,
    rating: 8.7,
    heat: 8320,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20retro%20horror%20series%20poster%20of%20teens%20with%20flashlights%20before%20a%20glowing%20portal%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv06cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20retro%20horror%20series%20still%20of%20a%201980s%20american%20small%20town%20at%20dusk%20with%20storm%20clouds%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv06back&orientation=landscape",
    summary: "霍金斯小镇的秘密再度被揭开，伙伴们分散各地却共同面对来自颠倒世界的黑暗力量。这是最终的序章。",
    cast: ["米莉·波比·布朗", "薇诺娜·瑞德", "大卫·哈伯"],
    episodes: [
      { index: 1, title: "第1集 地狱火俱乐部" },
      { index: 2, title: "第2集 维克那的诅咒" },
      { index: 3, title: "第3集 颠倒世界" },
      { index: 4, title: "第4集 最后的对决" },
    ],
  },
  {
    id: "t7",
    title: "长相思",
    category: "tv",
    genre: "古装",
    region: "中国大陆",
    year: 2023,
    rating: 7.9,
    heat: 7860,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20romance%20series%20poster%20of%20a%20girl%20in%20elegant%20robes%20among%20falling%20petals%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv07cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20romance%20series%20still%20of%20a%20lakeside%20pavilion%20with%20lotus%20flowers%20at%20sunset%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv07back&orientation=landscape",
    summary: "流落凡间的小夭历经百年漂泊，与多位男子结下不解之缘。爱与权谋交织的古装情感史诗。",
    cast: ["杨紫", "张晚意", "邓为"],
    episodes: [
      { index: 1, title: "第1集 清水镇" },
      { index: 2, title: "第2集 故人归" },
      { index: 3, title: "第3集 长相思" },
      { index: 4, title: "第4集 天下大乱" },
    ],
  },
  {
    id: "t8",
    title: "苍兰诀",
    category: "tv",
    genre: "古装",
    region: "中国大陆",
    year: 2022,
    rating: 7.7,
    heat: 7200,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20costume%20series%20poster%20of%20a%20fairy%20and%20a%20demon%20lord%20under%20a%20glowing%20moon%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20dramatic%20lighting%2C%20centered%20composition%2C%20detailed%20poster%20art&width=400&height=600&seq=tv08cover&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20series%20still%20of%20a%20celestial%20palace%20among%20clouds%20and%20glowing%20lanterns%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv08back&orientation=landscape",
    summary: "小兰花与魔尊东方青苍因意外交换身体，从欢喜冤家到生死相许。一段仙魔之恋就此展开。",
    cast: ["虞书欣", "王鹤棣", "张凌赫"],
    episodes: [
      { index: 1, title: "第1集 交换身体" },
      { index: 2, title: "第2集 魔尊的秘密" },
      { index: 3, title: "第3集 苍兰之约" },
      { index: 4, title: "第4集 生死相许" },
    ],
  },
];

export const featuredSlides = [
  {
    id: "m1",
    title: "流浪地球3",
    tag: "独家焦点",
    desc: "行星发动机全功率启动，人类最后的赌注即将揭晓。",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20still%20of%20a%20colossal%20planetary%20engine%20towering%20above%20a%20snow%20covered%20city%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20moody%20atmosphere%2C%20highly%20detailed&width=1600&height=900&seq=mv01back&orientation=landscape",
  },
  {
    id: "t1",
    title: "狂飙",
    tag: "本周热播",
    desc: "二十年的正邪较量，一个时代的选择与代价。",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20crime%20series%20still%20of%20an%20old%20southern%20chinese%20city%20street%20at%20dusk%20with%20warm%20lights%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=tv01back&orientation=landscape",
  },
  {
    id: "m7",
    title: "沙丘2",
    tag: "热门推荐",
    desc: "在命运的沙暴中，英雄与预言一同苏醒。",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20still%20of%20vast%20orange%20desert%20dunes%20with%20a%20colossal%20sandworm%20rising%20under%20a%20hazy%20sky%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20detailed&width=1600&height=900&seq=mv07back&orientation=landscape",
  },
];

export const genres = ["动作", "科幻", "悬疑", "剧情", "喜剧", "犯罪", "古装", "动画", "奇幻", "传记", "惊悚"];

export const regions = ["中国大陆", "美国", "日本", "韩国", "中国香港"];

export const years = [2025, 2024, 2023, 2022, 2019, 2016];